import { render, staticRenderFns } from "./SplashScreen.vue?vue&type=template&id=76ea0ed8&scoped=true&"
import script from "./SplashScreen.vue?vue&type=script&lang=js&"
export * from "./SplashScreen.vue?vue&type=script&lang=js&"
import style0 from "./SplashScreen.vue?vue&type=style&index=0&id=76ea0ed8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ea0ed8",
  null
  
)

export default component.exports